module.exports = __webpack_public_path__ + "media/open_box_scroll.7134f.7fa719ba.mp3";